import { createSurveyStyles } from '@sm/webassets';
import { WrenchTheme } from '@wds/styles';

const useStyles = createSurveyStyles(surveyTheme => ({
  text: {
    color: surveyTheme.questionColor,
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '18px',
    fontFamily: WrenchTheme.type.fontFamily.base,
    display: 'inline-block',
    textDecoration: 'none',
  },
  reportContainer: {
    color: surveyTheme.questionColor,
    display: 'inline-block',
    lineHeight: '18px',
    fontSize: '12px',
    fontFamily: WrenchTheme.type.fontFamily.base,
    textDecoration: 'none',
  },
}));

export default useStyles;
